require('./angular-idle');
module.exports = 'ngIdle';
